import { npga } from '@common/utils/ga';

/**
 * The site-wide GA events — .in's @common/tracking/commonGATracking.js.
 *
 * Not ported from it: the `pageID` cookie (.in pins it to `.grabon.in` for
 * its own tracking, not for GA) and the GOTD banner click (an India-only
 * home element with no International equivalent).
 */
export function commonGATrackingInit() {
  npga('.go-logo', 'GrabOn Logo Click');
}
